module.exports = __webpack_public_path__ + "static/media/KassenLeistung01.adf85222.jpg";